// import React from "react";
// import { Navigate } from "react-router-dom";

// const PublicRoute = ({ children }) => {
//   const token = localStorage.getItem("token");
//   const role  = localStorage.getItem("role");

//   // If user is already logged in, don't let them see /login etc.
//   if (token) {
//     if (role === "admin") {
//       return <Navigate to="/admin/dashboard" replace />;
//     }
//     if (role === "servitor") {
//       return <Navigate to="/servitor" replace />;
//     }

//     // default for normal users
//     return <Navigate to="/profile/orderhistory" replace />;
//   }
//   return children;
// };

// export default PublicRoute;






// import React from "react";
// import { Navigate, useLocation } from "react-router-dom";

// const PublicRoute = ({ children }) => {
//   const location = useLocation();

//   const userToken  = localStorage.getItem("token");
//   const adminToken = localStorage.getItem("adminToken");
//   const rawRole    = localStorage.getItem("role") || "";
//   const role       = rawRole.trim().toLowerCase(); // "user" | "servitor" | "admin" | ""

//   // 🔐 If admin is logged in, never show public pages
//   if (adminToken && role === "admin") {
//     return (
//       <Navigate
//         to="/admin/dashboard"
//         state={{ from: location }}
//         replace
//       />
//     );
//   }

//   // 🔐 If servitor is logged in, keep them in servitor area
//   if (userToken && role === "servitor") {
//     return (
//       <Navigate
//         to="/servitor"
//         state={{ from: location }}
//         replace
//       />
//     );
//   }

//   // 🔐 If normal user is logged in, send to profile (or /home if you prefer)
//   if (userToken && role === "user") {
//     return (
//       <Navigate
//         to="/profile"
//         state={{ from: location }}
//         replace
//       />
//     );
//   }

//   // Not logged in → show the public page normally
//   return children;
// };

// export default PublicRoute;






import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const PublicRoute = ({ children }) => {
  const location = useLocation();

  const userToken  = localStorage.getItem("token");
  const adminToken = localStorage.getItem("adminToken");
  const rawRole    = localStorage.getItem("role") || "";
  const role       = rawRole.trim().toLowerCase(); // "user" | "servitor" | "admin" | ""

  //  Admin: always keep inside admin area
  if (adminToken && role === "admin") {
    return (
      <Navigate
        to="/admin/dashboard"
        state={{ from: location }}
        replace
      />
    );
  }

  //  Servitor: always keep inside servitor area
  if (userToken && role === "servitor") {
    return (
      <Navigate
        to="/servitor"
        state={{ from: location }}
        replace
      />
    );
  }

  //  Normal logged-in user: allow public pages
  // (user can see Home, About, Services, etc.)
  // Just render the child route:
  return children;
};

export default PublicRoute;
